module.exports = __webpack_public_path__ + "img/iphone-bg.5da28222.svg";